import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

export interface BillingAddress {
  address: Address
  countries: Countries[]
  states: States[]
  firstName: string
  lastName: string
}

export interface Address {
  address1: string
  address2: string
  cityId: number
  cityName: string
  cityCustom: string
  stateId: number
  stateCode: string
  stateName: string
  zip: string
  countryId: number
  countryName: string
}

export interface Countries {
  countryId: number
  countryName: string
}

export interface States {
  stateName: string
  stateCode: string
  stateId: number
}

// GET /billing_address
export const billingAddress = async () => {
  const response = await new Request().get('/ajax/billing_address')
  return Util.Obj.keysToCamel(response.data.billing_address_info) as BillingAddress
}
